module.exports = __webpack_public_path__ + "assets/ac193fa9c483bf0938107559bc8d6912.png";